<template>
    <div class="image-upload-container">
        <input type="file" ref="inputArquivo" @change="handleImageUpload" accept="image/*" style="display: none" />
        <div class="image-display" @click="abrirSeletorArquivo">
            <span v-if="!modelValue" class="image-placeholder">
                {{ modelValue || 'Imagem.png' }}
            </span>
            <img v-else :src="modelValue" alt="Preview" class="image-preview" />
            <div class="image-actions">
                <button v-if="modelValue" type="button" class="image-remove-btn" @click.stop="removerImagem" title="Remover imagem">
                    <span class="material-symbols-outlined">close</span>
                </button>
                <button type="button" class="image-upload-btn">
                    <span class="material-symbols-outlined">upload</span>
                </button>
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref, defineEmits, defineProps } from 'vue';

const emit = defineEmits(['update:modelValue']);
const inputArquivo = ref(null);

defineProps({
    label: {
        type: String,
    },
    modelValue: {
        type: String,
        default: null,
    },
});

const abrirSeletorArquivo = () => {
    if (inputArquivo.value) {
        inputArquivo.value.click();
    }
};

function handleImageUpload(event) {
    const file = event.target.files[0];
    if (file) {
        emit('update:modelValue', file);
    }
}

function removerImagem() {
    emit('update:modelValue', null);
}
</script>
<style scoped lang="scss">
.image-upload-container {
    width: 100%;
}
.image-display {
    position: relative;
    width: 100%;
    min-height: 44px;
    border: 1px solid #ddd;
    border-radius: 4px;
    background: #f8f9fa;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    transition: all 0.2s ease;
}
.image-display:hover {
    border-color: #0f97c7;
    background: #f0f8ff;
}
.image-placeholder {
    color: #666;
    font-size: 14px;
}
.image-preview {
    max-width: 100px;
    max-height: 32px;
    object-fit: cover;
    border-radius: 4px;
}
.image-actions {
    display: flex;
    gap: 4px;
    align-items: center;
}
.image-upload-btn {
    background: none;
    border: none;
    color: #0f97c7;
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.image-upload-btn:hover {
    background: rgba(15, 151, 199, 0.1);
}
.image-remove-btn {
    background: none;
    border: none;
    color: #dc2626;
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
}
.image-remove-btn:hover {
    background: rgba(220, 38, 38, 0.1);
}
.material-symbols-outlined {
    font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 24;
    font-size: 20px;
}
</style>
